module.exports = __webpack_public_path__ + "img/globalIcon1.7a71df07.png";